import React, { useState } from "react";
import { api } from "@/lib/config";
import { useT } from "@/lib/i18n";
import { Mail, Check, ArrowRight } from "lucide-react";

export default function NewsletterForm() {
  const t = useT();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errMsg, setErrMsg] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading"); setErrMsg("");
    try {
      await api.post("/contact", {
        name: "Newsletter",
        email,
        company: "",
        phone: "",
        subject: t("newsletter.subjectEmail"),
        message: t("newsletter.messageBody", "Inscription à la newsletter Wedo Coaching."),
      });
      setStatus("success");
      setEmail("");
    } catch (err) {
      setStatus("error");
      setErrMsg(err.response?.data?.detail || t("newsletter.error"));
    }
  };

  return (
    <div data-testid="newsletter-form" className="p-6 border-t border-ink/10 bg-paper-2">
      <div className="flex items-center gap-2 mb-3">
        <Mail size={16} className="text-accent-pink" />
        <p className="display italic text-base text-brand">{t("newsletter.title")}</p>
      </div>
      <p className="text-[13px] leading-relaxed text-ink/85">
        {t("newsletter.lede")}
      </p>

      {status === "success" ? (
        <div className="mt-4 flex items-start gap-2 text-brand">
          <Check size={16} className="mt-0.5 shrink-0" />
          <p className="text-[13px] leading-relaxed">{t("newsletter.success")}</p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="mt-4 space-y-2">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("newsletter.placeholder")}
            data-testid="newsletter-email"
            className="w-full bg-paper border border-ink/15 px-4 py-2.5 text-[14px] focus:border-brand outline-none transition-colors"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            data-testid="newsletter-submit"
            className="w-full bg-brand text-white text-[13px] font-bold tracking-wider uppercase py-2.5 hover:bg-accent-pink transition-colors disabled:opacity-60 inline-flex items-center justify-center gap-2"
          >
            {status === "loading" ? t("newsletter.sending") : (<>{t("newsletter.submit")} <ArrowRight size={14}/></>)}
          </button>
          {status === "error" && (
            <p className="text-accent-pink text-[12px] mt-1">{errMsg}</p>
          )}
        </form>
      )}

      <p className="text-[11px] text-ink/60 mt-3 leading-relaxed">
        {t("newsletter.privacy")}
      </p>
    </div>
  );
}
